// Renders raw HTML docs inside a sandboxed iframe so their styles/scripts stay isolated from the app
const HtmlView = ({ url }) => (
    <iframe
        title="Design document"
        src={url}
        sandbox=""
        className="w-full min-h-[75vh] border border-border-light rounded-lg bg-white"
    />
);

export default HtmlView;
